//Made following Changes on the Contacts Tab
// Label for Student Changed to President
// Label for Riskmgt Changed to Risk Manager

import React, { Component } from "react";
import {
  Input,
  Label,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import axios from "axios";
import { Button } from "reactstrap";
import DeleteConfirmationModal from "./DeleteConfirmationModal";

class OrgDetailsAdmin extends Component {
  state = {
    activeTab: "1",
    AdvisorEmail: this.props.orgName.AdvisorEmail,
    AdvisorName: this.props.orgName.AdvisorName,
    AdvisorPhone: this.props.orgName.AdvisorPhone,
    AutoID: this.props.orgName.AutoID,
    ChapterName: this.props.orgName.ChapterName,
    Charter: this.props.orgName.Charter,
    Comments: this.props.orgName.Comments,
    Constitution: this.props.orgName.Constitution,
    Description: this.props.orgName.Description,
    Email: this.props.orgName.Email,
    Keywords: this.props.orgName.Keywords,
    KirkContract: this.props.orgName.KirkContract.toString(),
    Name: this.props.orgName.Name,
    RiskMgtDone: this.props.orgName.RiskMgtDone,
    RiskMgtEmail: this.props.orgName.RiskMgtEmail,
    RiskMgtName: this.props.orgName.RiskMgtName,
    RiskMgtPhone: this.props.orgName.RiskMgtPhone,
    Size: this.props.orgName.Size,
    Standing: this.props.orgName.Standing,
    StudentContact: this.props.orgName.StudentContact,
    StudentEmail: this.props.orgName.StudentEmail,
    StudentPhone: this.props.orgName.StudentPhone,
    FinancialManagerName: this.props.orgName.FinancialManagerName,
    FinancialManagerEmail: this.props.orgName.FinancialManagerEmail,
    FinancialManagerPhone: this.props.orgName.FinancialManagerPhone,
    RosterManagerName: this.props.orgName.RosterManagerName,
    RosterManagerEmail: this.props.orgName.RosterManagerEmail,
    RosterManagerPhone: this.props.orgName.RosterManagerPhone,
    Type: this.props.orgName.Type,
    URL: this.props.orgName.URL,
    Infos: "",
    Renewals: "",
    MembersFall: "",
    MembersSpring: "",
    Rosters: "",
    Workshops: "",
    Advisors: "",
    RiskMgts: "",
    FinancialRisks:"",
    deleteInfos: false,
    deleteRenewals: false,
    deleteRosters: false,
    deleteWorkshops: false,
    deleteAdvisors: false,
    deleteRiskMgts: false,
    deleteFinancialRisks: false,
    year: ""
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  onChange = (e, i) => {
    //console.log(e.target.name, e.target.value);
    //console.log(e.target);
    this.setState({ [e.target.name]: e.target.value, year: i });
  };

  onRadioInfoButtonChange = (isCurrentYear) => {
    var date = new Date();
    var thisYear = date.getFullYear();
    if (
      isCurrentYear !== null &&
      isCurrentYear
        .toString()
        .substring(isCurrentYear.length - 1, isCurrentYear.length) !== "D"
    ) {
      this.setState({ Infos: isCurrentYear });
    }
    else if(isCurrentYear === null) {
      //console.log(isCurrentYear);
    }
     else {
      this.setState({
        Infos: isCurrentYear.substring(0, isCurrentYear.length - 1),
        deleteInfos: true,
      });
    }
  };

  onRadioRecognitionButtonChange = (isCurrentYear) => {
    //console.log(isCurrentYear);
    //console.log(this.state.Renewals);
    if (
      isCurrentYear !== null &&
      isCurrentYear
        .toString()
        .substring(isCurrentYear.length - 1, isCurrentYear.length) !== "D"
    ) {
      this.setState({ Renewals: isCurrentYear });
      
    } 
   else if(isCurrentYear === null) {
    //console.log(isCurrentYear);
  }
    else {
      this.setState({
        Renewals: isCurrentYear.substring(0, isCurrentYear.length - 1),
        deleteRenewals: true,
      });
    }
  };

  onRadioRostersButtonChange = (isCurrentYear) => {
    //console.log(isCurrentYear);
    //console.log(this.state.Renewals);
    if (
      isCurrentYear !== null &&
      isCurrentYear
        .toString()
        .substring(isCurrentYear.length - 1, isCurrentYear.length) !== "D"
    ) {
      this.setState({ Rosters: isCurrentYear });
    } else if(isCurrentYear === null) {
      //console.log(isCurrentYear);
    }
    else{
      this.setState({
        Rosters: isCurrentYear.substring(0, isCurrentYear.length - 1),
        deleteRosters: true,
      });
      
    }
   
  };

  onRadioWorkshopsButtonChange = (isCurrentYear) => {
    if (
      isCurrentYear !== null &&
      isCurrentYear
        .toString()
        .substring(isCurrentYear.length - 1, isCurrentYear.length) !== "D"
    ) {
      this.setState({ Workshops: isCurrentYear });
    }
    else if(isCurrentYear === null) {
      //console.log(isCurrentYear);
    }
    else {
      this.setState({
        Workshops: isCurrentYear.substring(0, isCurrentYear.length - 1),
        deleteWorkshops: true,
      });
    }
  };

  onRadioAdvisorButtonChange = (isCurrentYear) => {
    if (
      isCurrentYear !== null &&
      isCurrentYear
        .toString()
        .substring(isCurrentYear.length - 1, isCurrentYear.length) !== "D"
    ) {
      this.setState({ Advisors: isCurrentYear });
    } 
    else if(isCurrentYear === null) {
      //console.log(isCurrentYear);
    }
    else {
      this.setState({
        Advisors: isCurrentYear.substring(0, isCurrentYear.length - 1),
        deleteAdvisors: true,
      });
    }
  };

  onRadioRiskMgtButtonChange = (isCurrentYear) => {
    //console.log(isCurrentYear);
    if (
      isCurrentYear !== null &&
      isCurrentYear
        .toString()
        .substring(isCurrentYear.length - 1, isCurrentYear.length) !== "D"
    ) {
      this.setState({ RiskMgts: isCurrentYear, year: isCurrentYear.substring(0, isCurrentYear.length - 1)});
      //console.log(this.state.RiskMgts);
      //console.log(this.state.year);
    }
    else if(isCurrentYear === null) {
      //console.log(isCurrentYear);
    }
    else {
      this.setState({
        RiskMgts: isCurrentYear.substring(0, isCurrentYear.length - 1),
        year: isCurrentYear.substring(0, isCurrentYear.length - 2),
        deleteRiskMgts: true,
      });
    }
    
  };

  onRadioFinancialRiskButtonChange = (isCurrentYear) => {
    if (
      isCurrentYear !== null &&
      isCurrentYear
        .toString()
        .substring(isCurrentYear.length - 1, isCurrentYear.length) !== "D"
    ) {
      this.setState({ FinancialRisks: isCurrentYear });
      //console.log(this.state.FinancialRisks);
    } 
  else if(isCurrentYear === null) {
    //console.log(isCurrentYear);
  }
    else {
      this.setState({
        FinancialRisks: isCurrentYear.substring(0, isCurrentYear.length - 1),
        deleteFinancialRisks: true,
      });
    }
  };

  postOrg = () => {
    let AdvisorEmail = this.state.AdvisorEmail;
    let AdvisorName = this.state.AdvisorName;
    let AdvisorPhone = this.state.AdvisorPhone;
    let AutoID = this.state.AutoID;
    let ChapterName = this.state.ChapterName;
    let Charter = this.state.Charter;
    let Comments = this.state.Comments;
    let Constitution = this.state.Constitution;
    let Description = this.state.Description;
    let Email = this.state.Email;
    let Keywords = this.state.Keywords;
    let KirkContract = this.state.KirkContract;
    let Name = this.state.Name;
    let RiskMgtDone = this.state.RiskMgtDone;
    let RiskMgtEmail = this.state.RiskMgtEmail;
    let RiskMgtName = this.state.RiskMgtName;
    let RiskMgtPhone = this.state.RiskMgtPhone;
    let Size = this.state.Size;
    let Standing = this.state.Standing;
    let StudentContact = this.state.StudentContact;
    let StudentEmail = this.state.StudentEmail;
    let StudentPhone = this.state.StudentPhone;
    let FinancialManagerName = this.state.FinancialManagerName;
    let FinancialManagerEmail = this.state.FinancialManagerEmail;
    let FinancialManagerPhone = this.state.FinancialManagerPhone;
    let RosterManagerName = this.state.RosterManagerName;
    let RosterManagerEmail = this.state.RosterManagerEmail;
    let RosterManagerPhone = this.state.RosterManagerPhone;
    let Type = this.state.Type;
    let URL = this.state.URL;

    let Infos = this.state.Infos;
    let Renewals = this.state.Renewals;
    let Members = "";
    let Rosters = this.state.Rosters;
    let Workshops = this.state.Workshops;
    let Advisors = this.state.Advisors;
    let RiskMgts = this.state.RiskMgts;
    let FinancialRisks = this.state.FinancialRisks;

    let deleteInfos = this.state.deleteInfos;
    let deleteRenewals = this.state.deleteRenewals;
    let deleteRosters = this.state.deleteRosters;
    let deleteWorkshops = this.state.deleteWorkshops;
    let deleteAdvisors = this.state.deleteAdvisors;
    let deleteRiskMgts = this.state.deleteRiskMgts;
    let deleteFinancialRisks = this.state.deleteFinancialRisks;

    var date = new Date();
    var thisYear = date.getFullYear();

    if (Rosters.charAt(Rosters.length - 1) === "S") {
      Members = this.state.MembersSpring;
    } else {
      Members = this.state.MembersFall;
    }

    let riskMgtYear = this.state.year;
    //console.log(deleteRiskMgts);
    //console.log(RiskMgts, riskMgtYear);
    // if (RiskMgts === currentClassYearFirstYear + "F") {
    //   riskMgtYear = currentClassYearFirstYear;
    // } else {
    //   riskMgtYear = currentClassYearFirstYear;
    // }

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    //Request body
    const body = JSON.stringify({
      AdvisorEmail,
      AdvisorName,
      AdvisorPhone,
      AutoID,
      ChapterName,
      Charter,
      Comments,
      Constitution,
      Description,
      Email,
      Keywords,
      KirkContract,
      Name,
      RiskMgtDone,
      RiskMgtEmail,
      RiskMgtName,
      RiskMgtPhone,
      Size,
      Standing,
      StudentContact,
      StudentEmail,
      StudentPhone,
      RosterManagerName,
      RosterManagerEmail,
      RosterManagerPhone,
      FinancialManagerName,
      FinancialManagerEmail,
      FinancialManagerPhone,
      Type,
      URL,
    });

    const bodyInfos = JSON.stringify({
      AutoID,
      Infos,
      deleteInfos,
    });

    const bodyRenewals = JSON.stringify({
      AutoID,
      Renewals,
      deleteRenewals,
    });

    const bodyRosters = JSON.stringify({
      AutoID,
      Rosters,
      deleteRosters,
      Members,
    });

    const bodyWorkshops = JSON.stringify({
      AutoID,
      Workshops,
      deleteWorkshops,
    });

    const bodyAdvisors = JSON.stringify({
      AutoID,
      Advisors,
      deleteAdvisors,
    });

    const bodyRiskMgts = JSON.stringify({
      AutoID,
      riskMgtYear,
      deleteRiskMgts,
    });

    const bodyFinancialRisks = JSON.stringify({
      AutoID,
      FinancialRisks,
      deleteFinancialRisks,
    });
    axios.post("/api/orgs/org", body, config).then((response) => {
      axios.post("api/orgs/infos/id", bodyInfos, config).then((response) => {
        axios
          .post("/api/orgs/renewals/id", bodyRenewals, config)
          .then((response) => {
            axios
              .post("api/orgs/rosters/id", bodyRosters, config)
              .then((response) => {
                axios
                  .post("api/orgs/workshops/id", bodyWorkshops, config)
                  .then((response) => {
                    axios
                    .post("api/orgs/financialRisks/id", bodyFinancialRisks, config)
                    .then((response) => {
                      axios
                        .post("api/orgs/advisors/id", bodyAdvisors, config)
                        .then((response) => {
                          if (RiskMgts === riskMgtYear + "F") {
                            //console.log("hereF");
                            axios
                              .post("api/orgs/riskmgt/id", bodyRiskMgts, config)
                              .then((response) => {
                                this.props.getNewOrgsUpdate();
                                this.props.toggle();
                              });
                          } else {
                            //console.log("hereS");
                            axios
                              .post("api/orgs/riskmgt2/id", bodyRiskMgts, config)
                              .then((response) => {
                                this.props.getNewOrgsUpdate();
                                this.props.toggle();
                              });
                          }
                        });
                  });
                  });
              });
          });
      });
    });
  };

  createinfoBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();
    //console.log(thisMonth);

    let currentClassYearFirstYear = thisYear;

    if (thisMonth+1 >= 8) {
      currentClassYearFirstYear = thisYear + 1;
    }

    let infoBlock = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      let thisChecked = false;

      //console.log(this.props.info);
      if (this.props.info) {
        this.props.info.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked = true;
          }
        });
      }
      infoBlock.push(
        <div key={i}>
          <p>
            {(i-1) + "-" + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>
              <input
                name={"Info" + i}
                id={"Info" + i}
                type="radio"
                value={true}
                defaultChecked={thisChecked === true}
                onChange={() =>
                  this.onRadioInfoButtonChange(
                    // i === currentClassYearFirstYear
                    //   ? currentClassYearFirstYear
                    //   : null
                    i
                  )
                }
              />
              <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
            </b>
            <b>
              <input
                name={"Info" + i}
                id={"Info" + i + "F"}
                type="radio"
                value={false}
                defaultChecked={thisChecked === false}
                onChange={() =>
                  this.onRadioInfoButtonChange(
                    // i === currentClassYearFirstYear
                    //   ? currentClassYearFirstYear + "D"
                    //   : null
                    i + "D"
                  )
                }
              />
              <font color="red"> No&nbsp;&nbsp;&nbsp;</font>
            </b>
          </p>
        </div>
      );
    }
    return infoBlock;
  };

  createRenewalBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    if (thisMonth+1 >= 8) {
      currentClassYearFirstYear = thisYear + 1;
    }

    let renewalBlock = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      let thisChecked = "false";

      if (this.props.renewal) {
        this.props.renewal.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked = "true";
          }
        });
      }

      renewalBlock.push(
        <div key={i}>
          <p>
            {(i-1) + "-" + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>
              <input
                name={"Renewal" + i}
                id={"Renewal" + i}
                type="radio"
                value="true"
                defaultChecked={thisChecked === "true"}
                onChange={() =>
                  this.onRadioRecognitionButtonChange(
                    // i === currentClassYearFirstYear
                    //   ? currentClassYearFirstYear
                    //   : null
                    i
                  )
                }
              />
              <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
            </b>
            <b>
              <input
                name={"Renewal" + i}
                id={"Renewal" + i + "F"}
                type="radio"
                value="false"
                defaultChecked={thisChecked === "false"}
                onChange={() =>
                  this.onRadioRecognitionButtonChange(
                    // i === currentClassYearFirstYear
                    //   ? currentClassYearFirstYear + "D"
                    //   : null
                    i + "D"
                  )
                }
              />
              <font color="red"> No</font>
            </b>
          </p>
        </div>
      );
    }

    return renewalBlock;
  };

  createRosterBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentSemester = "";

    if (thisMonth+1 < 8) {
      currentSemester = "S";
    } else {
      currentSemester = "F";
    }

    let rosterBlock = [];

    for (let i = 2017; i <= thisYear; i++) {
      let thisSpringChecked = "false";
      let thisFallChecked = "false";
      let thisSpringCount = "";
      let thisFallCount = "";

      if (this.props.roster) {
        this.props.roster.forEach((element) => {
          let thisLoopYear = element.year;
          let thisCount = element.members;

          if (thisLoopYear == i + "S") {
            thisSpringChecked = "true";
            thisSpringCount = thisCount;
          }

          if (thisLoopYear == i + "F") {
            thisFallChecked = "true";
            thisFallCount = thisCount;
          }
        });
      }

      if (i >= 2017) {
        rosterBlock.push(
          <div key={i}>
            <div>
              <p>
                {"Spring " + i} :&nbsp;&nbsp;
                <b>
                  <b>
                    <input
                      name={"RosterSpring" + i}
                      id={"RosterSpring" + i}
                      type="radio"
                      value="true"
                      defaultChecked={thisSpringChecked === "true"}
                      onChange={() =>
                        this.onRadioRostersButtonChange(
                          // i === thisYear && currentSemester === "S"
                          //   ? thisYear + "S"
                          //   : null
                          i + "S"
                        )
                      }
                    />
                    <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
                  </b>
                  <b>
                    <input
                      name={"RosterSpring" + i}
                      id={"RosterSpring" + i + "F"}
                      type="radio"
                      value="false"
                      defaultChecked={thisSpringChecked === "false"}
                      onChange={() =>
                        this.onRadioRostersButtonChange(
                          // i === thisYear && currentSemester === "S"
                          //   ? thisYear + "S" + "D"
                          //   : null
                          i + "S" + "D"
                        )
                      }
                    />
                    <font color="red"> No</font>
                  </b>
                  &nbsp;&nbsp;
                  <font>
                    {" "}
                    Number of Members :{" "}
                    <Input
                      style={{ width: "60px", display: "inline" }}
                      type="text"
                      name="MembersSpring"
                      id={"MembersSpring" + i}
                      value={
                        // i === thisYear &&
                        // currentSemester === "S" &&
                        // thisSpringCount
                        //   ? thisSpringCount
                        //   : i === thisYear && currentSemester === "S"
                        //   ? this.state.MembersSpring
                        //   : thisSpringCount
                        //   ? thisSpringCount
                        //   : ""
                        thisSpringCount ? thisSpringCount : i==this.state.year && this.state.MembersSpring ? this.state.MembersSpring:""
                      }
                      onChange={(e)=>this.onChange(e, i)}
                    />{" "}
                  </font>
                </b>
              </p>
            </div>
            <div>
              <p>
                {"Fall " + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b>
                  <b>
                    <input
                      name={"RosterFall" + i}
                      id={"RosterFall" + i}
                      type="radio"
                      value="true"
                      defaultChecked={thisFallChecked === "true"}
                      onChange={() =>
                        this.onRadioRostersButtonChange(
                          // i === thisYear && currentSemester === "F"
                          //   ? thisYear + "F"
                          //   : null
                          i + "F"
                        )
                      }
                    />
                    <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
                  </b>
                  <b>
                    <input
                      name={"RosterFall" + i}
                      id={"RosterFall" + i + "FF"}
                      type="radio"
                      value="false"
                      defaultChecked={thisFallChecked === "false"}
                      onChange={() =>
                        this.onRadioRostersButtonChange(
                          // i === thisYear && currentSemester === "F"
                          //   ? thisYear + "F" + "D"
                          //   : null
                          i + "F" + "D"
                        )
                      }
                    />
                    <font color="red"> No</font>
                  </b>
                  &nbsp;&nbsp;
                  <font>
                    {" "}
                    Number of Members :{" "}
                    <Input
                      style={{ width: "60px", display: "inline" }}
                      type="text"
                      name="MembersFall"
                      id={"MembersFall" + i}
                      value={
                        // i === thisYear &&
                        // currentSemester === "F" &&
                        // thisFallCount
                        //   ? thisFallCount
                        //   : i === thisYear && currentSemester === "F"
                        //   ? this.state.MembersFall
                        //   : thisFallCount
                        //   ? thisFallCount
                        //   : ""
                        thisFallCount ? thisFallCount : i==this.state.year && this.state.MembersFall ? this.state.MembersFall:""
                      }
                      onChange={(e)=>this.onChange(e,i)}
                    />
                  </font>
                </b>
              </p>
            </div>
          </div>
        );
      }
    }

    return rosterBlock;
  };

  createFinancialRiskBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    var currentSemester = "";

    if (thisMonth+1 < 8) {
      currentSemester = "S";
    } else {
      currentSemester = "F";
    }

    let financialRiskBlock = [];

    for (let i = 2017; i <= thisYear; i++) {
      let thisSpringChecked = "false";
      let thisFallChecked = "false";

      if (this.props.financialRisk) {
        this.props.financialRisk.forEach((element) => {
          let thisLoopYear = element.year;
          if (thisLoopYear == i + "S") {
            thisSpringChecked = "true";
          }

          if (thisLoopYear == i + "F") {
            thisFallChecked = "true";
          }
        });
      }

      if (i >= 2017) {
        financialRiskBlock.push(
          <div key={i}>
            <div>
              <p>
                {"Spring " + i} :&nbsp;&nbsp;
                <b>
                  <b>
                    <input
                      name={"FinancialRiskSpring" + i}
                      id={"FinancialRiskSpring" + i}
                      type="radio"
                      value="true"
                      defaultChecked={thisSpringChecked === "true"}
                      onChange={() =>
                        this.onRadioFinancialRiskButtonChange(
                          // i === thisYear && currentSemester==="S"
                          //   ? thisYear + "S"
                          //   : null
                          i + "S"
                        )
                      }
                    />
                    <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
                  </b>
                  <b>
                    <input
                      name={"FinancialRiskSpring" + i}
                      id={"FinancialRiskSpring" + i + "F"}
                      type="radio"
                      value="false"
                      defaultChecked={thisSpringChecked === "false"}
                      onChange={() =>
                        this.onRadioFinancialRiskButtonChange(
                          // i === thisYear && currentSemester==="S"
                          //   ? thisYear + "S" + "D"
                          //   : null
                          i + "S" + "D"
                        )
                      }
                    />
                    <font color="red"> No</font>
                  </b>
                  &nbsp;&nbsp;
                </b>
              </p>
            </div>
            <div>
              <p>
                {"Fall " + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b>
                  <b>
                    <input
                      name={"FinancialRiskFall" + i}
                      id={"FinancialRiskFall" + i}
                      type="radio"
                      value="true"
                      defaultChecked={thisFallChecked === "true"}
                      onChange={() =>
                        this.onRadioFinancialRiskButtonChange(
                          // i === thisYear && currentSemester==="F"
                          //   ? thisYear + "F"
                          //   : null
                          i + "F"
                        )
                      }
                    />
                    <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
                  </b>
                  <b>
                    <input
                      name={"FinancialRiskFall" + i}
                      id={"FinancialRiskFall" + i + "FF"}
                      type="radio"
                      value="false"
                      defaultChecked={thisFallChecked === "false"}
                      onChange={() =>
                        this.onRadioFinancialRiskButtonChange(
                          // i === thisYear && currentSemester==="F"
                          //   ? thisYear + "F" + "D"
                          //   : null
                          i + "F" + "D"
                        )
                      }
                    />
                    <font color="red"> No</font>
                  </b>
                  &nbsp;&nbsp;
                </b>
              </p>
            </div>
          </div>
        );
      }
    }

    return financialRiskBlock;
  };

  createWorkshopBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    if (thisMonth+1 >= 8) {
      currentClassYearFirstYear = thisYear + 1;
    }

    let workshopBlock = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      let thisChecked = "false";

      if (this.props.workshop) {
        this.props.workshop.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked = "true";
          }
        });
      }

      workshopBlock.push(
        <div key={i}>
          <p>
            {(i-1) + "-" + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>
              <input
                name={"Workshop" + i}
                id={"Workshop" + i}
                type="radio"
                value="true"
                defaultChecked={thisChecked === "true"}
                onChange={() =>
                  this.onRadioWorkshopsButtonChange(
                    // i === currentClassYearFirstYear
                    //   ? currentClassYearFirstYear
                    //   : null
                    i
                  )
                }
              />
              <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
            </b>
            <b>
              <input
                name={"Workshop" + i}
                id={"Workshop" + i + "F"}
                type="radio"
                value="false"
                defaultChecked={thisChecked === "false"}
                onChange={() =>
                  this.onRadioWorkshopsButtonChange(
                    // i === currentClassYearFirstYear
                    //   ? currentClassYearFirstYear + "D"
                    //   : null
                    i + "D"
                  )
                }
              />
              <font color="red"> No</font>
            </b>
          </p>
        </div>
      );
    }

    return workshopBlock;
  };

  createAdvisorBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    if (thisMonth+1 >= 8) {
      currentClassYearFirstYear = thisYear + 1;
    }

    let advisorBlock = [];

    for (let i = 2017; i <= currentClassYearFirstYear; i++) {
      let thisChecked = "false";

      if (this.props.advisor) {
        this.props.advisor.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked = "true";
          }
        });
      }

      advisorBlock.push(
        <div key={i}>
          <p>
            {(i-1) + "-" + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>
              <input
                name={"Advisor" + i}
                id={"Advisor" + i}
                type="radio"
                value="true"
                defaultChecked={thisChecked === "true"}
                onChange={() =>
                  this.onRadioAdvisorButtonChange(
                    // i === currentClassYearFirstYear
                    //   ? currentClassYearFirstYear
                    //   : null
                    i
                  )
                }
              />
              <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
            </b>
            <b>
              <input
                name={"Advisor" + i}
                id={"Advisor" + i + "F"}
                type="radio"
                value="false"
                defaultChecked={thisChecked === "false"}
                onChange={() =>
                  this.onRadioAdvisorButtonChange(
                    // i === currentClassYearFirstYear
                    //   ? currentClassYearFirstYear + "D"
                    //   : null
                    i + "D"
                  )
                }
              />
              <font color="red"> No</font>
            </b>
          </p>
        </div>
      );
    }

    return advisorBlock;
  };

  createRiskMgtBlock = () => {
    var date = new Date();
    var thisYear = date.getFullYear();
    var thisMonth = date.getMonth();

    let currentClassYearFirstYear = thisYear;

    // if (thisMonth < 8) {
    //   currentClassYearFirstYear = thisYear - 1;
    // }

    let riskMgtBlock = [];

    for (let i = 2017; i <= thisYear; i++) {
      let thisChecked = "false";
      let thisChecked2 = "false";
      var currentSemester = "";

      if (this.props.riskmgt) {
        this.props.riskmgt.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked = "true";
            currentSemester = "F";
          }
        });
      }

      if (this.props.riskmgt2) {
        this.props.riskmgt2.forEach((element) => {
          let thisLoopYear = element.year;

          if (thisLoopYear == i) {
            thisChecked2 = "true";
            currentSemester = "S";
          }
        });
      }
      //console.log(currentSemester);
      riskMgtBlock.push(
        <div key={i}>
          <div>
            <p>
              {"Spring " + i} :&nbsp;&nbsp;
              <b>
                <input
                  name={"RiskMgmtSpring" + i}
                  id={"RiskMgmtSpring" + i}
                  type="radio"
                  value="true"
                  defaultChecked={thisChecked2 === "true"}
                  onChange={() =>
                    this.onRadioRiskMgtButtonChange(
                      // i === thisYear && currentSemester==="S"
                      //   ? thisYear + "S"
                      //   : null
                      i + "S"
                    )
                  }
                />
                <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
              </b>
              <b>
                <input
                  name={"RiskMgmtSpring" + i}
                  id={"RiskMgmtSpring" + i + "F"}
                  type="radio"
                  value="false"
                  defaultChecked={thisChecked2 === "false"}
                  onChange={() =>
                    this.onRadioRiskMgtButtonChange(
                      // i === thisYear && currentSemester==="S"
                      //   ? thisYear + "S" + "D"
                      //   : null
                      i  + "S" + "D"
                    )
                  }
                />
                <font color="red"> No</font>
              </b>
            </p>
          </div>
          <div>
            <p>
              {"Fall " + i} :&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>
                <input
                  name={"RiskMgmtFall" + i}
                  id={"RiskMgmtFall" + i}
                  type="radio"
                  value="true"
                  defaultChecked={thisChecked === "true"}
                  onChange={() =>
                    this.onRadioRiskMgtButtonChange(
                      // i === thisYear && currentSemester==="F"
                      //   ? thisYear + "F"
                      //   : null
                       i + "F"
                    )
                  }
                />
                <font color="green"> Yes&nbsp;&nbsp;&nbsp;</font>
              </b>
              <b>
                <input
                  name={"RiskMgmtFall" + i}
                  id={"RiskMgmtFall" + i + "FF"}
                  type="radio"
                  value="false"
                  defaultChecked={thisChecked === "false"}
                  onChange={() =>
                    this.onRadioRiskMgtButtonChange(
                      // i === thisYear && currentSemester==="F"
                      //   ? thisYear + "F" + "D"
                      //   : null
                      i + "F" + "D"
                    )
                  }
                />
                <font color="red"> No</font>
              </b>
            </p>
          </div>
        </div>
      );
    }

    return riskMgtBlock;
  };

  render() {
    return (
      <div>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "1" })}
              onClick={() => {
                this.toggle("1");
              }}>
              Basics
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "2" })}
              onClick={() => {
                this.toggle("2");
              }}>
              Contacts
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "3" })}
              onClick={() => {
                this.toggle("3");
              }}>
              Status
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "4" })}
              onClick={() => {
                this.toggle("4");
              }}>
              Recognition
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "5" })}
              onClick={() => {
                this.toggle("5");
              }}>
              Info
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "6" })}
              onClick={() => {
                this.toggle("6");
              }}>
              Rosters
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "7" })}
              onClick={() => {
                this.toggle("7");
              }}>
              Workshops
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "8" })}
              onClick={() => {
                this.toggle("8");
              }}>
              Advisor
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "9" })}
              onClick={() => {
                this.toggle("9");
              }}>
              Description
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "10" })}
              onClick={() => {
                this.toggle("10");
              }}>
              Comments
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "11" })}
              onClick={() => {
                this.toggle("11");
              }}>
              Physical Risk
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: this.state.activeTab === "12" })}
              onClick={() => {
                this.toggle("12");
              }}>
              Financial Risk
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col sm="6">
                <Label for="Name">Organization Name:</Label>
                <Input
                  type="text"
                  name="Name"
                  id="Name"
                  value={this.state.Name}
                  onChange={this.onChange}
                />
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="Chapter">Chapter:</Label>
                <Input
                  type="text"
                  name="ChapterName"
                  id="Chapter"
                  value={this.state.ChapterName}
                  onChange={this.onChange}
                />
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="Type">Type:</Label>
                <br />
                <select
                  className="form-control"
                  id="Type"
                  name="Type"
                  value={this.state.Type}
                  onChange={this.onChange}>
                  <option value="Academic/Professional">
                    Academic/Professional
                  </option>
                  <option value="Media and Publications">
                    Media and Publications
                  </option>
                  <option value="Cultural/Intercultural/Identity-Based">
                    Cultural/Intercultural/Identity-Based
                  </option>
                  <option value="Fee-Based">Fee-Based</option>
                  <option value="Arts and Entertainment">
                    Arts and Entertainment
                  </option>
                  <option value="Political and Activism">
                    Political and Activism
                  </option>
                  <option value="Fraternity and Sorority Life">Fraternity and Sorority Life</option>
                  <option value="Health and Wellness">
                    Health and Wellness
                  </option>
                  <option value="Honorary">Honorary</option>
                  <option value="Recreational/Sports">
                    Recreational/Sports
                  </option>
                  <option value="Spiritual/Faith-Based">
                    Spiritual/Faith-Based
                  </option>
                  <option value="Residential Living">Residential Living</option>
                  <option value="Service">Service</option>
                  <option value="Special Interest">Special Interest</option>
                  <option value="University Department">
                    University Department
                  </option>
                  <option value="Departmental Student Organizations">
                    Departmental Student Organizations{" "}
                  </option>
                  <option value="Faculty Led Honor Societies">
                    Faculty Led Honor Societies
                  </option>
                  <option value="Social">Social</option>
                  <option value="Environmental/Sustainability">
                    Environmental/Sustainability
                  </option>
                </select>
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="URL">URL:</Label>

                <Input
                  type="url"
                  name="URL"
                  id="URL"
                  value={this.state.URL}
                  onChange={this.onChange}
                />

                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <Label for="Name">Organization Email:</Label>

                <Input
                  type="email"
                  name="Email"
                  id="Email"
                  value={this.state.Email}
                  onChange={this.onChange}
                />

                <br />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="1"></Col>
                  <Col sm="2">
                    <Label for="Student">President</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="Advisor">Advisor</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="RiskMgt">Risk Manager</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="FinancialManager">Financial Manager</Label>
                  </Col>
                  <Col sm="2">
                    <Label for="RosterManager">Roster Manager</Label>
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">Name</Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="StudentContact"
                      id="StudentContact"
                      value={this.state.StudentContact}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="AdvisorName"
                      id="AdvisorName"
                      value={this.state.AdvisorName}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RiskMgtName"
                      id="RiskMgtName"
                      value={this.state.RiskMgtName}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="FinancialManagerName"
                      id="FinancialManagerName"
                      value={
                        this.state.FinancialManagerName
                          ? this.state.FinancialManagerName
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RosterManagerName"
                      id="RosterManagerName"
                      value={
                        this.state.RosterManagerName
                          ? this.state.RosterManagerName
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">Email</Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="StudentEmail"
                      id="StudentEmail"
                      value={this.state.StudentEmail}
                      onChange={this.onChange}
                    />
                  </Col>

                  <Col sm="2">
                    <Input
                      type="text"
                      name="AdvisorEmail"
                      id="AdvisorEmail"
                      value={this.state.AdvisorEmail}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RiskMgtEmail"
                      id="RiskMgtEmail"
                      value={this.state.RiskMgtEmail}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="FinancialManagerEmail"
                      id="FinancialManagerEmail"
                      value={
                        this.state.FinancialManagerEmail
                          ? this.state.FinancialManagerEmail
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RosterManagerEmail"
                      id="RosterManagerEmail"
                      value={
                        this.state.RosterManagerEmail
                          ? this.state.RosterManagerEmail
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">Phone</Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="StudentPhone"
                      id="StudentPhone"
                      value={this.state.StudentPhone}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="AdvisorPhone"
                      id="AdvisorPhone"
                      value={this.state.AdvisorPhone}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RiskMgtPhone"
                      id="RiskMgtPhone"
                      value={this.state.RiskMgtPhone}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="FinancialManagerPhone"
                      id="FinancialManagerPhone"
                      value={
                        this.state.FinancialManagerPhone
                          ? this.state.FinancialManagerPhone
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col sm="2">
                    <Input
                      type="text"
                      name="RosterManagerPhone"
                      id="RosterManagerPhone"
                      value={
                        this.state.RosterManagerPhone
                          ? this.state.RosterManagerPhone
                          : ""
                      }
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="2">Standing</Col>
                  <Col sm="10">
                    <div className="mb-3">
                      <input
                        type="radio"
                        name="Standing"
                        id="StandingGood"
                        value="Good"
                        checked={this.state.Standing === "Good"}
                        onChange={this.onChange}
                      />{" "}
                      Good &nbsp;&nbsp;
                      <input
                        name="Standing"
                        id="StandingBad"
                        type="radio"
                        value="Bad"
                        checked={this.state.Standing === "Bad"}
                        onChange={this.onChange}
                      />{" "}
                      Bad &nbsp;&nbsp;
                      <input
                        name="Standing"
                        id="StandingChar"
                        type="radio"
                        value="Chartering"
                        checked={this.state.Standing === "Chartering"}
                        onChange={this.onChange}
                      />{" "}
                      Chartering &nbsp;&nbsp;
                      <input
                        name="Standing"
                        id="StandingPro"
                        type="radio"
                        value="Provisional"
                        checked={this.state.Standing === "Provisional"}
                        onChange={this.onChange}
                      />{" "}
                      Provisional &nbsp;&nbsp;
                      <input
                        name="Standing"
                        id="Standing"
                        type="radio"
                        value="Inactive"
                        checked={this.state.Standing === "Inactive"}
                        onChange={this.onChange}
                      />{" "}
                      Inactive
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Kirk Contract</Col>
                  <Col sm="3">
                    <div className="mb-3">
                      <input
                        name="KirkContract"
                        id="KirkContract"
                        type="radio"
                        value="true"
                        checked={this.state.KirkContract === "true"}
                        onChange={this.onChange}
                      />{" "}
                      <label className="form-check-label">
                        Yes &nbsp;&nbsp;
                      </label>
                      <input
                        name="KirkContract"
                        id="KirkContract2"
                        type="radio"
                        value="false"
                        checked={this.state.KirkContract === "false"}
                        onChange={this.onChange}
                      />{" "}
                      <label className="form-check-label">
                        No &nbsp;&nbsp;
                      </label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Constitution Date</Col>
                  <Col sm="3">
                    <Input
                      type="text"
                      name="Constitution"
                      id="Constitution"
                      value={this.state.Constitution}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Charter</Col>
                  <Col sm="3">
                    <Input
                      type="text"
                      name="Charter"
                      id="Charter"
                      value={this.state.Charter}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="3">Size</Col>
                  <Col sm="3">
                    <Input
                      type="text"
                      name="Size"
                      id="Size"
                      value={this.state.Size}
                      onChange={this.onChange}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="4">
            <Row>
              <Col sm="12">
                <Col sm="12">{this.createRenewalBlock()}</Col>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="5">
            <Row>
              <Col sm="12">{this.createinfoBlock()}</Col>
            </Row>
          </TabPane>
          <TabPane tabId="6">
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="12">{this.createRosterBlock()}</Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="7">
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="12">{this.createWorkshopBlock()}</Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="8">
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="12">{this.createAdvisorBlock()}</Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="9">
            <Row>
              <Col sm="12">
                <Label for="Description">Description:</Label>
                <Input
                  type="textarea"
                  name="Description"
                  id="Description"
                  value={this.state.Description}
                  onChange={this.onChange}
                />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="10">
            <Row>
              <Col sm="12">
                <Label for="CSI Notes">CSI Notes:</Label>
                <Input
                  type="textarea"
                  name="Comments"
                  id="Comments"
                  value={this.state.Comments}
                  onChange={this.onChange}
                />
                <br />
              </Col>
            </Row>
            <Row>
              <Col sm="12">
                <Label for="Keywords">Search Keywords:</Label>
                <Input
                  type="textarea"
                  name="Keywords"
                  id="Keywords"
                  value={this.state.Keywords}
                  onChange={this.onChange}
                />
                <br />
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="11">
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="12">{this.createRiskMgtBlock()}</Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="12">
            <Row>
              <Col sm="12">
                <Row>
                  <Col sm="12">{this.createFinancialRiskBlock()}</Col>
                </Row>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
        <div className="d-flex align-items-center">
        <Button
          color="primary"
          onClick={() => {
            this.postOrg();
          }}>
          Save
        </Button>
        <Button className="ml-2 mr-2" color="secondary" onClick={this.props.toggle}>
          Close
        </Button>
        <DeleteConfirmationModal AutoID={this.state.AutoID} Name={this.state.Name} close={this.props.toggle} getNewOrgsUpdate={this.props.getNewOrgsUpdate}/>
        </div>
      </div>
    );
  }
}

export default OrgDetailsAdmin;
